<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ item.product }} {{ item.size }} {{ item.pack }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="submit"
              :loading="loading"
              :disabled="step != 2"
              >Toevoegen</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-container v-show="step == 0">
          <v-btn
            @click="selectProduct(product.id)"
            :loading="loadProduct[product.id]"
            v-for="product in products"
            :key="product.id"
            :color="product.color"
            :class="product.blackText ? 'black--text mt-2' : 'white--text mt-2'"
            style="width: 100%"
            >{{ product.id }}</v-btn
          >
        </v-container>

        <v-container v-show="step == 1">
          <v-card v-for="key in Object.keys(available)" :key="key" class="mt-2">
            <v-card-title>{{ key }}</v-card-title>
            <v-card-text>
              <v-btn
                class="ma-2 white--text"
                color="blue"
                v-for="size in available[key]"
                :key="size"
                @click="selectCombo(key, size)"
                >{{ size }}</v-btn
              >
            </v-card-text>
          </v-card>
        </v-container>

        <v-container v-show="step == 2">
          <v-card>
            <v-card-title>Aantal</v-card-title>
            <v-card-text>
              <v-text-field v-model="item.amount"></v-text-field>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="3">
                  <!-- <table id="amountTable">
                    <tr>
                      <td><v-btn @click="add(7)">7</v-btn></td>
                      <td><v-btn @click="add(8)">8</v-btn></td>
                      <td><v-btn @click="add(9)">9</v-btn></td>
                    </tr>
                    <tr>
                      <td><v-btn @click="add(4)">4</v-btn></td>
                      <td><v-btn @click="add(5)">5</v-btn></td>
                      <td><v-btn @click="add(6)">6</v-btn></td>
                    </tr>
                    <tr>
                      <td><v-btn @click="add(1)">1</v-btn></td>
                      <td><v-btn @click="add(2)">2</v-btn></td>
                      <td><v-btn @click="add(3)">3</v-btn></td>
                    </tr>
                    <tr>
                      <td><v-btn @click="add(0)">0</v-btn></td>
                      <td colspan="2">
                        <v-btn style="width: 100%" @click="clear">C</v-btn>
                      </td>
                    </tr>
                  </table> -->
                  <ul class="numpad">
                    <li rel="1"><v-btn @click="add(7)" fab text>7</v-btn></li>
                    <li rel="2"><v-btn @click="add(8)" fab text>8</v-btn></li>
                    <li rel="3"><v-btn @click="add(9)" fab text>9</v-btn></li>
                    <li rel="4"><v-btn @click="add(4)" fab text>4</v-btn></li>
                    <li rel="5"><v-btn @click="add(5)" fab text>5</v-btn></li>
                    <li rel="6"><v-btn @click="add(6)" fab text>6</v-btn></li>
                    <li rel="7"><v-btn @click="add(1)" fab text>1</v-btn></li>
                    <li rel="8"><v-btn @click="add(2)" fab text>2</v-btn></li>
                    <li rel="9"><v-btn @click="add(3)" fab text>3</v-btn></li>
                    <li rel="."></li>
                    <li rel="0"><v-btn @click="add(0)" fab text>0</v-btn></li>
                    <li rel="delete">
                      <v-btn @click="clear" fab text>C</v-btn>
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" id="quickAdd">
                  <v-btn @click="quickAdd(5)">5</v-btn>
                  <v-btn @click="quickAdd(40)">40</v-btn>
                  <v-btn @click="quickAdd(60)">60</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="submit" style="width: 25%"
                >Ok</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-container>
        <v-container>
          <v-btn
            @click="step--"
            v-if="step != 0"
            text
            color="indigo"
            class="white--text"
            style="width: 100%"
            ><span
              ><v-icon left class="primary--text">mdi-arrow-left</v-icon></span
            >
            <span>Terug</span>
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { firestore } from "firebase";
export default {
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    order: {
      type: String,
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  data() {
    return {
      step: 0,
      packs: ["PAK", "VAK", "EPS", "PL6", "PLX"],
      available: {},
      item: {
        product: "",
        pack: "",
        size: "",
        amount: "",
      },
      products: [],
      loading: false,
      loadProduct: {},
    };
  },
  mounted() {
    this.fetchProducts();
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    handleKey(key) {
      if (this.step == 2) {
        if (key.keyCode === 8) {
          this.item.amount = this.item.amount.slice(
            0,
            this.item.amount.length - 1
          );
        }
        if (isFinite(key.key)) {
          this.item.amount += key.key;
        }
      }
    },
    async fetchProducts() {
      let _self = this;
      let products = await firestore()
        .collection("Products")
        .where("enabled", "==", true)
        .get();
      products.forEach((product) => {
        _self.loadProduct[product.id] = false;
        _self.products.push({
          id: product.id,
          ...product.data(),
        });
      });
    },
    async submit() {
      await firestore()
        .collection(`Orders/${this.order}/items`)
        .add({
          ...this.item,
        });
      this.show = false;
      this.item = {
        product: "",
        pack: "",
        size: "",
        amount: "",
      };
      this.step = 0;
      this.available = {};
    },
    async selectProduct(product) {
      this.item.product = product;
      this.loadProduct[product] = true;
      let _self = this;
      for (var i = 0; i <= _self.packs.length - 1; i++) {
        let packList = await firestore()
          .collection("Products/" + product + "/" + _self.packs[i])
          .get();
        if (packList.size > 0) {
          _self.available[_self.packs[i]] = packList.docs.map((e) => e.id);
        }
      }
      this.loadProduct[product] = false;
      this.step = 1;
    },
    selectCombo(pack, size) {
      this.item.pack = pack;
      this.item.size = size;
      this.step++;
    },
    add(num) {
      this.item.amount = String(this.item.amount) + String(num);
    },
    clear() {
      this.item.amount = "";
    },
    quickAdd(num) {
      this.item.amount = String(num);
      this.submit();
    },
  },
};
</script>

<style scoped>
.numpad {
  margin: 0;
  padding: 0;
  bottom: 0;
  width: 320px;
}

.numpad li {
  font-size: 32px;
  float: left;
  list-style: none;
  text-align: center;
  height: 65px;
  padding-top: 15px;
  width: 33.33%;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#quickAdd button {
  margin: 5px;
  width: calc(33% - 10px);
}
</style>